import React from 'react';

const Processing = ({ ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9997 10.6666C11.2633 10.6666 10.6663 11.2635 10.6663 11.9999C10.6663 12.7363 11.2633 13.3333 11.9997 13.3333C12.7361 13.3333 13.333 12.7363 13.333 11.9999C13.333 11.2635 12.7361 10.6666 11.9997 10.6666ZM9.33301 11.9999C9.33301 10.5272 10.5269 9.33325 11.9997 9.33325C13.4724 9.33325 14.6663 10.5272 14.6663 11.9999C14.6663 13.4727 13.4724 14.6666 11.9997 14.6666C10.5269 14.6666 9.33301 13.4727 9.33301 11.9999Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99967 2.66659C3.26329 2.66659 2.66634 3.26354 2.66634 3.99992C2.66634 4.7363 3.26329 5.33325 3.99967 5.33325C4.73605 5.33325 5.33301 4.7363 5.33301 3.99992C5.33301 3.26354 4.73605 2.66659 3.99967 2.66659ZM1.33301 3.99992C1.33301 2.52716 2.52691 1.33325 3.99967 1.33325C5.47243 1.33325 6.66634 2.52716 6.66634 3.99992C6.66634 5.47268 5.47243 6.66658 3.99967 6.66658C2.52691 6.66658 1.33301 5.47268 1.33301 3.99992Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.99992C8 3.63173 8.29848 3.33325 8.66667 3.33325H10.6667C11.1971 3.33325 11.7058 3.54397 12.0809 3.91904C12.456 4.29411 12.6667 4.80282 12.6667 5.33325V9.99992C12.6667 10.3681 12.3682 10.6666 12 10.6666C11.6318 10.6666 11.3333 10.3681 11.3333 9.99992V5.33325C11.3333 5.15644 11.2631 4.98687 11.1381 4.86185C11.013 4.73682 10.8435 4.66659 10.6667 4.66659H8.66667C8.29848 4.66659 8 4.36811 8 3.99992Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.99967 5.33325C4.36786 5.33325 4.66634 5.63173 4.66634 5.99992V13.9999C4.66634 14.3681 4.36786 14.6666 3.99967 14.6666C3.63148 14.6666 3.33301 14.3681 3.33301 13.9999V5.99992C3.33301 5.63173 3.63148 5.33325 3.99967 5.33325Z"
        fill="white"
      />
    </svg>
  );
};

export default Processing;
